// extracted by mini-css-extract-plugin
export var bannerContainer = "VideoModal-module--bannerContainer--BaKzy";
export var ctaContainer = "VideoModal-module--ctaContainer--itgvd";
export var ctaTitle = "VideoModal-module--ctaTitle---9192";
export var desktopBanner = "VideoModal-module--desktopBanner--gQHbD";
export var mobileBanner = "VideoModal-module--mobileBanner--tZOfz";
export var overlayContent = "VideoModal-module--overlayContent--WrX4Q";
export var playButton = "VideoModal-module--playButton--87oSt";
export var playButtonText = "VideoModal-module--playButtonText--Zaruh";
export var playIcon = "VideoModal-module--playIcon--7A0il";
export var videoContent = "VideoModal-module--videoContent--1eXmk";
export var videoModalWrapper = "VideoModal-module--videoModalWrapper--Owd+W";